import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { environment } from 'src/environments/environment.prod';
import { BrowserService } from 'src/_lib/service/browser.service';
import { DynamicThemeClassService } from 'src/_lib/service/dynamic-theme-class.service';

@Component({
  selector: 'app-sub-footer',
  templateUrl: './sub-footer.component.html',
  styleUrls: ['./sub-footer.component.scss'],
  standalone: true,
  imports: [NgIf,NgClass],
  encapsulation: ViewEncapsulation.None
})
export class SubFooterComponent implements OnInit {
  imgBasePath: string = environment.imageBasePath;
  commonImagePath= environment.commonImagePath;
  footerdata: any;
  menuLink: string = '';
  chTheme1 = environment.chTheme1;
  chTheme3 = environment.chTheme3;
  chTheme4 = environment.chTheme4;
  chTheme7 = environment.chTheme7;
  chTheme11 = environment.chTheme11;
  chTheme15 = environment.chTheme15;



  @Input() showSocialIconsCopyright: boolean = null;

  constructor(private browser: BrowserService,  private dynamicThemeClassService: DynamicThemeClassService) {}

  ngOnInit(): void {
    this.getFooterDataFromLocalstorage();
  }

 getFooterDataFromLocalstorage(): void {
  if (!this.browser.isBrowser) {
    return;
  }
  const footerData = this.browser.localStorage?.getItem('footerData');
  if (!footerData) {
    console.warn('No footer data found in localStorage');
    return;
  }
  try {
    const footerArray = JSON.parse(footerData)?.socialIconsCopyright;
    if (Array.isArray(footerArray)) {
      this.footerdata = footerArray.find(
        item => item.menu_name === 'Copyright Info'
      );
      if (this.footerdata?.menu_link) {
        this.menuLink = this.replaceYearWithCurrent(
          this.footerdata.menu_link
        );
      }
    }
  } catch (error) {
    console.error('Error parsing footer data from localStorage', error);
  }
}

  replaceYearWithCurrent(menuLink: string): string {
    const currentYear = new Date().getFullYear();
    return menuLink.replace(/© \d{4}/, `© ${currentYear}`);
  }

themeClass(divName: string): string {
  return this.dynamicThemeClassService.generateClassName(divName);
}

}